import React from "react"
import autobind from "class-autobind"
import { Dialog, TextField, FlatButton, CircularProgress } from "material-ui"
import Table from "../common/Table"
import { TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import strings from "../../localization/strings"
import Clear from "../../components/misc/Clear"
import AccountStore from "../../stores/AccountStore"
import { IJobDocument } from "../../models"
import * as api from "../../api"
import { orange700, red500 } from "material-ui/styles/colors"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import { debounce } from "lodash"
import AppStateStore from "../../stores/AppStateStore"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"
import { checkPhaseFieldAvailable } from "../../helpers/punchHelper"
interface IProps {
	jobs: IJobDocument[]
	filterHierarchyId: string
	multiSelectable: boolean
	restrictHierarchy: boolean
	handleClose(): void
	handleSave(jobs: IJobDocument[]): void
	clientId?: string
	//it's for punch to assigned job only
	punchEmployeeId?: string
}
interface IState {
	jobs: IJobDocument[]
	selectedJobs: IJobDocument[]
	search: string
	loading: boolean
	total: number
	offset: number
}

export default class AddJobDialogForChip extends React.Component<IProps, IState> {
	private limit
	private searchField
	constructor(props) {
		super(props)
		this.state = {
			jobs: [],
			selectedJobs: [],
			search: "",
			loading: true,
			offset: 0,
			total: 0
		}
		autobind(this)
		const tempLimit = Math.floor(window.innerHeight / 50) - 9
		this.limit = tempLimit > 8 ? 8 : tempLimit
	}

	componentDidMount() {
		this.getJobs()
	}

	async getJobs() {
		const reponse = await api.getJobs(
			AccountStore.getCurrentAccount().Id,
			this.props.filterHierarchyId ? this.props.filterHierarchyId : "",
			this.state.offset / this.limit,
			this.limit,
			this.state.search,
			true,
			false,
			this.props.restrictHierarchy === true,
			this.props.punchEmployeeId ? this.props.punchEmployeeId : "",
			this.props.clientId ? this.props.clientId : ""
		)

		this.setState({
			jobs: reponse.data.Documents,
			total: reponse.data.TotalDocumentCount,
			loading: false
		})
	}

	offsetChange(offset) {
		this.setState({
			offset,
			loading: true
		}, () =>
			this.getJobs()
		)
	}

	searchJob = debounce(() => this.getJobs(), 1000)

	render() {
		const duplicated = this.props.jobs.find(i => this.state.selectedJobs.find(k => k.Id === i.Id)) !== undefined
		return (
			<Dialog
				modal
				open
				title={ checkJobFieldAvailable('singular')  ? `Choose ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` :strings.Choose_Job}
				actions={[
					this.props.multiSelectable &&
					<span style={{ fontSize: 19, marginRight: 75, color: duplicated && orange700 }}>
						{duplicated ?
							strings.Duplicated_Job_exist :
							this.state.selectedJobs.length > 0 &&
							strings.formatString(strings.x_Job_Selected, this.state.selectedJobs.length)
						}
					</span>,
					<FlatButton
						data-intercom-target={"Close-Job-Selection-Dialog"}
						label={strings.Cancel}
						secondary
						onClick={this.props.handleClose}
					/>,
					<FlatButton
						data-intercom-target={"Save-Selected-Job"}
						label={strings.OK}
						primary
						keyboardFocused
						disabled={duplicated}
						onClick={() =>
							this.state.selectedJobs.find(i => hierarchyHelper.getFullPathLabel(i.HierarchyId) === strings.Hierarchy_Removed) ?
								AppStateStore.setProgressSnackbarContent(strings.Cannot_choose_invalid_job) :
								this.props.handleSave(this.state.selectedJobs)
						}
					/>
				]}
				onRequestClose={this.props.handleClose}
			>
				<div data-intercom-target={"Job-Selection-Dialog"}>
					<div style={{ padding: 20, paddingLeft: 35 }}>
						<i style={{ fontSize: 25, cursor: "pointer" }} className="fa fa-search" onClick={() => this.searchField.focus()} />
						<TextField
							hintText={strings.search}
							style={{ marginRight: 20, width: "90%", marginLeft: 15 }}
							value={this.state.search}
							onChange={(e, search) => {
								this.setState({
									search,
									offset: 0,
									loading: true,
									selectedJobs: []
								})
								this.searchJob()
							}}
							ref={item => this.searchField = item}
						/>
						<Clear />
					</div>
					<div style={{ textAlign: "center", height: 500 }}>
						{this.state.loading ?
							<CircularProgress /> :
							<Table
								items={this.state.jobs}
								selectedItems={this.state.jobs.filter(i => this.state.selectedJobs.find(k => i.Id === k.Id) !== undefined)}
								singleSelectable={!this.props.multiSelectable}
								handleSelect={jobs =>
									this.setState({
										selectedJobs: this.props.multiSelectable ?
											[...this.state.selectedJobs.filter(i => this.state.jobs.find(k => i.Id === k.Id) === undefined), ...jobs] :
											jobs
									})
								}
								total={this.state.total}
								offset={this.state.offset}
								limit={this.limit}
								onPageClick={this.offsetChange}
							>
								<TableHeader>
									<TableRow>
										<TableHeaderColumn className="TextOverflow" title={strings.Name} style={styles.nameCol}>{strings.Name}</TableHeaderColumn>
										{!this.props.restrictHierarchy &&
											<TableHeaderColumn className="TextOverflow" title={strings.Parent_Hierarchy} style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5 }}>{strings.Parent_Hierarchy}</TableHeaderColumn>
										}
										<TableHeaderColumn className="TextOverflow" title={strings.External_ID} style={styles.otherCol}>{strings.External_ID}</TableHeaderColumn>
										<TableHeaderColumn className="TextOverflow" title={strings.Cost_Code} style={styles.otherCol}>{strings.Cost_Code}</TableHeaderColumn>
										{AccountStore.getPhasesEnabled() &&
											<TableHeaderColumn className="TextOverflow" title={checkPhaseFieldAvailable("plural") ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.PluralPhaseLabel  : strings.Phases} style={styles.otherCol}>{checkPhaseFieldAvailable("plural") ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.PluralPhaseLabel  : strings.Phases}</TableHeaderColumn>
										}
									</TableRow>
								</TableHeader>
								<TableBody>
									{this.state.jobs.map((item, index) => {
										const hierarchyPathLabelToRoot = hierarchyHelper.getFullPathLabel(item.HierarchyId)
										return (
											<TableRow key={index} selected={this.state.selectedJobs.find(i => i.Id === item.Id) !== undefined}>
												<TableRowColumn style={styles.nameCol} title={item.Name}>{item.Name}</TableRowColumn>
												{!this.props.restrictHierarchy &&
													<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5, color: hierarchyPathLabelToRoot === strings.Hierarchy_Removed && red500 }} title={hierarchyPathLabelToRoot === strings.Hierarchy_Removed ? "" : hierarchyPathLabelToRoot}>
														{hierarchyPathLabelToRoot}
													</TableRowColumn>
												}
												<TableRowColumn style={styles.otherCol} title={item.ExternalId}>{item.ExternalId}</TableRowColumn>
												<TableRowColumn style={styles.otherCol} title={item.CostCode}>{item.CostCode}</TableRowColumn>
												{AccountStore.getPhasesEnabled() &&
													<TableRowColumn style={styles.otherCol}>{item.Phases && item.Phases.filter(i => i.Active && !i.Deleted).length}</TableRowColumn>
												}
											</TableRow>
										)
									})}
								</TableBody>
							</Table>
						}
					</div>
				</div>
			</Dialog>
		)
	}
}

const styles = {
	nameCol: {
		paddingLeft: 5,
		paddingRight: 5,
	},
	otherCol: {
		paddingLeft: 5,
		paddingRight: 5,
		width: 75
	}
}
